export const environment = {
    production: false,
    API_HOME: 'http://globaldemo.infisit.com/'
};
